import React from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useLocation } from "react-router-dom";

const AuthRequire: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation();

  React.useEffect(() => {
    const handleAuth = async () => {
      const isAuth = await oktaAuth.isAuthenticated();
      if (!isAuth) {
        const originalUri = location.pathname + location.search + location.hash;
        oktaAuth.signInWithRedirect({ originalUri });
      }
    };

    handleAuth();
  }, [oktaAuth, authState, location]);

  return <>{children}</>;
};

export default AuthRequire;
